import React, { useState } from 'react';
import { Plus, Trash2, ExternalLink, Link2 } from 'lucide-react';
import { domainOf, normalizeUrl } from './brandData';

export function LinkCard({ link, onRemove, testid }) {
  const host = domainOf(link.url);
  return (
    <div className="group flex items-center gap-3 bg-[#F8FAFC] border border-[#E2E8F0] rounded-xl px-3 py-2.5 hover:border-[#1D4ED8] hover:bg-white transition-colors" data-testid={testid}>
      <img src={`https://www.google.com/s2/favicons?domain=${host}&sz=64`} alt="" className="w-8 h-8 rounded-md bg-white border border-[#E2E8F0] p-1 shrink-0" />
      <a href={link.url} target="_blank" rel="noopener noreferrer" className="min-w-0 flex-1" data-testid={`${testid}-open`}>
        <div className="font-bold text-sm text-[#0A0F1C] truncate flex items-center gap-1.5 group-hover:text-[#1D4ED8]">{host} <ExternalLink size={12} className="shrink-0" /></div>
        {link.note ? <div className="text-xs text-[#64748B] truncate">{link.note}</div> : <div className="text-xs text-[#94A3B8] truncate">{link.url}</div>}
      </a>
      {onRemove && (
        <button type="button" onClick={onRemove} data-testid={`${testid}-remove`} className="text-[#CBD5E1] hover:text-red-500 p-1"><Trash2 size={15} /></button>
      )}
    </div>
  );
}

export default function LinkList({ title, hint, links, onChange, prefix, placeholderNote = 'what you like about it' }) {
  const [url, setUrl] = useState('');
  const [note, setNote] = useState('');
  const add = () => {
    const u = normalizeUrl(url);
    if (!u) return;
    onChange([...links, { url: u, note: note.trim() }]);
    setUrl(''); setNote('');
  };
  const onKey = (e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } };
  return (
    <div className="bg-white border border-[#E2E8F0] rounded-xl p-4" data-testid={`${prefix}-section`}>
      <div className="flex items-center gap-2 mb-1"><Link2 size={15} className="text-[#1D4ED8]" /><h4 className="font-bold text-sm text-[#0A0F1C]">{title}</h4></div>
      {hint && <p className="text-xs text-[#64748B] mb-3">{hint}</p>}
      <div className="flex flex-col sm:flex-row gap-2 mb-3">
        <input value={url} onChange={(e) => setUrl(e.target.value)} onKeyDown={onKey} placeholder="Paste a link, e.g. example.com" data-testid={`${prefix}-url-input`}
          className="flex-[3] px-3 py-2 rounded-lg border border-[#E2E8F0] text-sm focus:border-[#1D4ED8] outline-none" />
        <input value={note} onChange={(e) => setNote(e.target.value)} onKeyDown={onKey} placeholder={placeholderNote} data-testid={`${prefix}-note-input`}
          className="flex-[2] px-3 py-2 rounded-lg border border-[#E2E8F0] text-sm focus:border-[#1D4ED8] outline-none" />
        <button type="button" onClick={add} disabled={!url.trim()} data-testid={`${prefix}-add-btn`}
          className="inline-flex items-center justify-center gap-1 px-4 py-2 rounded-lg bg-[#1D4ED8] text-white text-sm font-bold hover:bg-[#1E40AF] disabled:opacity-40 transition-colors">
          <Plus size={16} /> Add
        </button>
      </div>
      {links.length === 0 ? (
        <div className="text-xs text-[#94A3B8] border border-dashed border-[#CBD5E1] rounded-lg py-4 text-center">No links yet — add one with the + button.</div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-2">
          {links.map((l, i) => (
            <LinkCard key={`${l.url}-${i}`} link={l} testid={`${prefix}-link-${i}`} onRemove={() => onChange(links.filter((_, j) => j !== i))} />
          ))}
        </div>
      )}
    </div>
  );
}
